<template>
  <div
    v-if="pages_count > 1"
    class="w-100 tc"
    id="table-paginator"
  >
    <Button
      class="btn"
      :disabled="page-1 <= 0"
      @click="goTo(page-1)"
    >Précédent</Button>
    <Button
      class="btn"
      v-if="page-2 > 0"
      @click="goTo(page-2)"
    >{{page-2}}</Button>
    <Button
      class="btn"
      v-if="page-1 > 0"
      @click="goTo(page-1)"
    >{{page-1}}</Button>
    <span class="current-page">
      {{ page }}
    </span>
    <Button
      class="btn"
      v-if="page+1 <= pages_count"
      @click="goTo(page+1)"
    >{{page+1}}</Button>
    <Button
      class="btn"
      v-if="page+2 <= pages_count"
      @click="goTo(page+2)"
    >{{page+2}}</Button>
    <Button
      class="btn"
      :disabled="page+1 > pages_count"
      @click="goTo(page+1)"
    >Suivant</Button>
  </div>
</template>

<script>
/* Import components */
export default {
  name: "table-paginator",
  props: ["per_page", "pages_count"],
  data: () => {
    return {
      page: 1
    };
  },
  mounted() {},
  methods: {
    goTo(page) {
      this.$emit("page-change", page);
      this.page = page;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.btn {
  background: rgb(42, 163, 214);
  color: white;
  margin: 0.25rem;
  border-radius: 5px;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
}

.btn.middle:focus {
  outline-width: 0;
  outline: none;
}

.current-page {
  font-weight: 900;
  margin: 0.55rem;
}
</style>